import React, {Component} from 'react';
import {connect} from 'react-redux';
import actions from './profile.actions';
import ProfileCard from './ProfileCard';
import UserProfileCard from './UserProfileCard';
import {DocumentTitle, EmptyMessage, Spinner, TaxonomyList, PrimaryButton} from '../widgets';
import './ProfileMetricsPage.css';
import {createSelector} from 'reselect';
import {uiActions} from '../chrome';
import {checkOnInit, checkOnPropChanges} from './profilePathCheck';
import fetchJson from '../fetchJson';
import handleError from '../handleError';
import Article from '../widgets/Article';

class ProfileMetricsPage extends Component {
	constructor(props) {
		super(props);

		this.state = {};

		checkOnInit(props);

		/**
		 * Find out who has favourited this provider
		 */
		this.retrieveFavouriters = providerUuid => {
			if (!providerUuid) return;

			fetchJson(`/api/providers/${providerUuid}/favouriters/providers`)
				.then(favouriters => this.setState({favouriters}))
				.catch(props.handleError);
		};

		this.retrieveFavouriters(this.props.profile && this.props.profile.uuid);
	}

	componentWillReceiveProps(nextProps) {
		checkOnPropChanges(nextProps, this.props);

		if (
			(nextProps.profile && nextProps.profile.uuid) !==
			(this.props.profile && this.props.profile.uuid)
		) {
			this.retrieveFavouriters(nextProps.profile && nextProps.profile.uuid);
		}
	}

	render() {
		if (
			!this.props.profile ||
			!this.props.profile.user ||
			!this.props.profile.profile ||
			!this.state.favouriters
		) {
			return (
				<DocumentTitle title="B2Me">
					<main className="ProfileMetricsPage">
						<Spinner />
					</main>
				</DocumentTitle>
			);
		}

		const {favouriters} = this.state;

		return (
			<DocumentTitle
				title={`${this.props.profile.user.firstname} ${this.props.profile.user.lastname} - B2Me`}>
				<main className="ProfileMetricsPage">
					<Article className="ProfileMetricsPage-followers">
						<h2>List of followers</h2>
						{!favouriters || !favouriters.length ? (
							<EmptyMessage>
								<div>
									<p>You haven't been added to anyone's collection yet</p>
									<p className="EmptyMessage-subtext">
										Invite your friends to B2Me to build up your network.
									</p>
								</div>
							</EmptyMessage>
						) : null}
						<ol>
							{favouriters &&
								favouriters.map(provider =>
									provider.subscriptionLevel === 'none' ? (
										<UserProfileCard key={provider && provider.uuid} profile={provider} />
									) : (
										<ProfileCard key={provider && provider.uuid} provider={provider} />
									)
								)}
						</ol>
					</Article>
				</main>
			</DocumentTitle>
		);
	}
}

const ConnectedProfileMetricsPage = connect(
	({profile, session}) => ({
		profile,
		sessionProvider: session && session.current,
		// ISSUE: this is derived state. It doesn't really belong in mapStateToProps
		editable:
			session.current &&
			session.current.user &&
			profile &&
			(session.current.user.admin || session.current.provider.uuid === profile.uuid)
	}),
	dispatch => ({
		handleError: () => handleError(dispatch),
		retrieveProfile: uniqueName => dispatch(actions.retrieveProfile(uniqueName)) // Expected for profile page signature
	})
)(ProfileMetricsPage);

export default ConnectedProfileMetricsPage;



// WEBPACK FOOTER //
// ./src/profile/ProfileMetricsPage.js